// extracted by mini-css-extract-plugin
module.exports = {"hint":"EComRichTextDescription_hint__3FBqj","title":"EComRichTextDescription_title__1Jpmz","detail":"EComRichTextDescription_detail__2lwId"};